export default "__VITE_ASSET__BP6YMUUN__"